export default __webpack_public_path__ + "static/lauren-86a74f2f2f810d85ef227be4f6633cd3.png";